import React from 'react';
import { translate } from 'react-i18next';

import * as Common from 'common/components';

const AssetLevelListTable = ({
  children,
  count,
  company,
  subcompany,
  permissions,
  handleToggle = () => {},
  handleOrderChange = () => {},
  order = '',
  orderBy = '',
  t,
}) => {
  const headers = [
    { variable: 'key', text: t('asset_level.fields.key') + ': ', type: 'h3' },
    { variable: 'name', text: t('asset_level.fields.name') + ': ' },
    { variable: 'role_to_acept', text: t('asset_level.fields.role_to_acept') + ': ' },
    {
      variable: 'active',
      text: t('asset_level.fields.active') + ': ',
      boolean: true,
    },
  ];

  const config = {
    actions: t('common.actions'), //Texto de seccion de acciones
    edit: t('common.edit'), //Texto de boton editar
    editPermission: 'acl.asset_level.update',
    togglePermission: 'acl.asset_level.toggle',
    editUrl: 'asset_level', //Url para editar empleado
    propsName: 'asset_level', //de donde se obtienen los props
    company: company,
    subcompany: subcompany,
  };

  const dataCard = {
    rows: children,
    headers: headers,
    config: config,
    permissions: permissions,
    handleClick: handleToggle,
  };

  return (
    <Common.List dataCard={dataCard}>
      <thead>
        <tr>
          <Common.ThSortable
            orderBy={orderBy}
            order={order}
            field="key"
            handleOrderChange={handleOrderChange}
          >
            {t('asset_level.fields.key')}
          </Common.ThSortable>

          <Common.ThSortable
            orderBy={orderBy}
            order={order}
            field="name"
            handleOrderChange={handleOrderChange}
          >
            {t('asset_level.fields.name')}
          </Common.ThSortable>

          <Common.ThSortable
            orderBy={orderBy}
            order={order}
            field="max_time"
            handleOrderChange={handleOrderChange}
          >
            {t('asset_level.fields.max_time')}
          </Common.ThSortable>
          <Common.ThSortable
            orderBy={orderBy}
            order={order}
            field="message_required"
            handleOrderChange={handleOrderChange}
          >
            {t('asset_level.fields.message_required')}
          </Common.ThSortable>
          <Common.ThSortable
            orderBy={orderBy}
            order={order}
            field="can_withdrawn"
            handleOrderChange={handleOrderChange}
          >
            {t('asset_level.fields.can_withdrawn')}
          </Common.ThSortable>

          <Common.ThSortable
            orderBy={orderBy}
            order={order}
            field="role_to_acept"
            handleOrderChange={handleOrderChange}
          >
            {t('asset_level.fields.role_to_acept')}
          </Common.ThSortable>

          <Common.ThSortable
            orderBy={orderBy}
            order={order}
            field="active"
            handleOrderChange={handleOrderChange}
            className="text-center"
          >
            {t('asset_level.fields.active')}
          </Common.ThSortable>

          <th className="text-center">{t('common.actions')}</th>
        </tr>
      </thead>

      <tbody>
        {count === 0 && <Common.EmptyTable colSpan={10} />}
        {children}
      </tbody>
    </Common.List>
  );
};

export default translate()(AssetLevelListTable);



// WEBPACK FOOTER //
// src/modules/secured/modules/asset_level/components/list/AssetLevelListTable.js